import { NgModule } from '@angular/core';
import { FiTimeAgoPipe } from './fi-time-ago.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [FiTimeAgoPipe],
    exports: [FiTimeAgoPipe],
})
export class FiTimeAgoPipeModule {}
